import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from "@angular/core";

@Directive({
  selector: "[appDragAndDropFile]",
})
export class DragAndDropFileDirective {
  @Input() disabledDragAndDrop: boolean;
  @Output() filesDrop: EventEmitter<File[]> = new EventEmitter<File[]>();

  @HostBinding("class.drag-over") active = false;

  @HostListener("drop", ["$event"])
  onFileDrop(event: DragEvent): void {
    this.active = false;
    event.preventDefault();
    event.stopPropagation();
    const files = [];

    if (event.dataTransfer.items) {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < event.dataTransfer.items.length; i++) {
        if (event.dataTransfer.items[i].kind === "file") {
          files.push(event.dataTransfer.items[i].getAsFile());
        }
      }

      event.dataTransfer.items.clear();
    } else {
      // eslint-disable-next-line @typescript-eslint/prefer-for-of
      for (let i = 0; i < event.dataTransfer.files.length; i++) {
        files.push(event.dataTransfer.files[i]);
      }
      event.dataTransfer.clearData();
    }

    this.filesDrop.emit(files);
  }

  @HostListener("dragover", ["$event"])
  onFileDropOver(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.active = true;
  }

  @HostListener("dragleave", ["$event"])
  onDragLeave() {
    this.active = false;
  }
}
